import { render, staticRenderFns } from "./ItemInfo.vue?vue&type=template&id=dc174fce"
import script from "./ItemInfo.vue?vue&type=script&lang=js"
export * from "./ItemInfo.vue?vue&type=script&lang=js"
import style0 from "./ItemInfo.vue?vue&type=style&index=0&id=dc174fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports